<template>
    <feedback-form ref="feedbackForm" :phone-by-country="false" :title="title" :description="description" :button="button" @send-form="submit"></feedback-form>
</template>

<script>
import ApiService from "../../api/api";
import FeedbackForm from "../../vue/FeedbackForm";

export default {
    name: "Services",
    props: ['title', 'description', 'button'],
    components: {FeedbackForm},
    methods: {
        submit: function(form) {
            return new Promise((resolve, reject) => {
                this.$loading(this.$optionsLoading);

                ApiService.post('/service/send-order', form)
                    .then((response) => {
                        this.$refs.feedbackForm.$emit('reset-form');

                        this.$appNotify.success(Vue.prototype.$lang('services.success'));

                        this.$router.go(-1);
                    })
                    .catch((error) => {
                        if(error.response.data.errors) {
                            this.$refs.feedbackForm.$emit('show-errors', error.response.data.errors);
                        } else {
                            this.$appNotify.error(Vue.prototype.$lang('services.error'));
                        }
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    });
            });
        }
    }
}
</script>
